export default __webpack_public_path__ + "static/media/ILLUST2.fb5c56d8.png";